import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_BASE_URL } from "../../config";
import DownloadButtons from "../DownloadButtons/DownloadButtons";
import EntriesSelector from "../Pagination/EntriesSelector";
import Pagination from "../Pagination/Paginations.js";
import Select from 'react-select';

const Attendance_summary = () => {
  const today = new Date().toISOString().split("T")[0];
  const [formData, setFormData] = useState({
    from_date: today,
    to_date: today,
    dept_id: "",
  });

  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState([]);
  const [dates, setDates] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  // 🔹 Fetch departments
  const handleDepartment = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/showdepartment`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      setDepartments(res.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load departments");
    }
  };

  useEffect(() => {
    handleDepartment();
  }, []);

  // 🔹 Handle input change
  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  // 🔹 Fetch attendance summary
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(
        `${API_BASE_URL}/attendancesummary`,
        {
          from_date: formData.from_date,
          to_date: formData.to_date,
          dept_id: formData.dept_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      setReport(Object.values(res.data.records));
      setDates(res.data.dates);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch attendance summary");
    }
    setLoading(false);
  };

  // 🔹 Flatten data for CSV/PDF
const generateFlatData = () => {
  return report.map((emp) => {
    const flatRow = {
      "Employee ID": emp.employee_id,
      "Employee Name": emp.employee_name,
      "Department": emp.department,
    };

    dates.forEach((date) => {
      const att = emp.attendance?.[date] || {};

      // 🔥 FIX: Stable header value
      const dayLabel = new Date(date).toISOString().split("T")[0];

      flatRow[`${dayLabel} - In`] = att.clock_in || "-";
      flatRow[`${dayLabel} - Out`] = att.clock_out || "-";
      flatRow[`${dayLabel} - TW`] = att.work_hour || "-";
      flatRow[`${dayLabel} - OT`] = att.overtime || "-";
      flatRow[`${dayLabel} - Shift`] = att.shift_code || "-";
    });

    return flatRow;
  });
};


  // 🔹 Pagination logic
  const totalPages = Math.ceil(report.length / entriesPerPage);
  const indexOfLast = currentPage * entriesPerPage;
  const indexOfFirst = indexOfLast - entriesPerPage;

  // 🔹 Search filter (by ID, name, or department)
  const filteredRecords = report.filter(
    (emp) =>
      emp.employee_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      emp.department?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      emp.employee_id?.toString().includes(searchTerm)
  );

  const currentRecords = filteredRecords.slice(indexOfFirst, indexOfLast);

  return (
    <div className="container mt-4">
      <ToastContainer />
      <div className="card shadow">
        <div className="card-header">
          <h3 className="card-title text-primary mb-0">
            Attendance Summary Report
          </h3>
        </div>

        <div className="card-body">
          <form onSubmit={handleSubmit} className="row g-3">
            <div className="col-md-3">
              <label>From Date</label>
              <input
                type="date"
                name="from_date"
                value={formData.from_date}
                onChange={handleChange}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label>To Date</label>
              <input
                type="date"
                name="to_date"
                value={formData.to_date}
                onChange={handleChange}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label>Department</label>
                 <Select
    name="dept_id"
    value={departments
      .map((dept) => ({
        value: dept.department_id,
        label: dept.department_name,
      }))
      .find((d) => d.value === formData.dept_id) || null}
    onChange={(selected) =>
      handleChange({
        target: { name: "dept_id", value: selected ? selected.value : "" },
      })
    }
    options={departments.map((dept) => ({
      value: dept.department_id,
      label: dept.department_name,
    }))}
    isClearable
    placeholder="All"
    className="basic-single"
  />
            </div>
        <div className="col-md-3 d-flex align-items-end">
  <button className="btn btn-primary btn-ls" type="submit">
    {loading ? "Loading..." : "Get"}
  </button>
</div>


          </form>
        </div>
      </div>

      {/* 🔹 Controls Section — only visible when data exists */}
      {report.length > 0 && (
        <div
          className="d-flex flex-wrap align-items-center justify-content-between my-3"
          style={{ gap: "1rem" }}
        >
          <div className="d-flex align-items-center gap-3">
            <DownloadButtons
              data={generateFlatData()}
              filename="attendance_summary_report"
            />

            <EntriesSelector
              entriesPerPage={entriesPerPage}
              setEntriesPerPage={setEntriesPerPage}
              setCurrentPage={setCurrentPage}
            />
          </div>

          {/* ✅ Search box floats right */}
          <div style={{ width: "250px" }}>
            <input
              type="text"
              placeholder="Search employee or dept..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
              className="form-control"
            />
          </div>
        </div>
      )}

      {/* 🔹 Table Section */}
      <div className="card mt-4">
        <div className="card-body table-responsive">
          {loading && <p className="text-center text-info">Loading...</p>}

          {!loading && report.length > 0 ? (
            <table className="table table-bordered text-center align-middle">
              <thead style={{ backgroundColor: "#7d858369" }}>
                {/* Top Row – Dates */}
                <tr
                 
                >
                  <th rowSpan="2">Employee Id</th>
                  <th rowSpan="2">Employee</th>
                  <th rowSpan="2">Department</th>
                  {dates.map((d, i) => (
                    <th key={i} colSpan="5">
                      {new Date(d).toLocaleDateString("en-GB")}
                    </th>
                  ))}
                </tr>

                {/* Sub-row – Column labels */}
                <tr
                 
                >
                  {dates.map((_, i) => (
                    <React.Fragment key={i}>
                      <th>In</th>
                      <th>Out</th>
                      <th>TW</th>
                      <th>OT</th>
                      <th>Shift</th>
                    </React.Fragment>
                  ))}
                </tr>
              </thead>

              <tbody>
                {currentRecords.map((emp, i) => (
                  <tr key={i}>
                    <td>{emp.employee_id}</td>
                    <td>{emp.employee_name}</td>
                    <td>{emp.department}</td>

                    {dates.map((date, j) => {
                      const att = emp.attendance?.[date] || {};
                      const style =
                        att.is_manual === "1"
                          ? { backgroundColor: "#198754", color: "#fff" } // Green highlight for manual updates
                          : {};
                      return (
                        <React.Fragment key={j}>
                          <td style={style}>{att.clock_in || "-"}</td>
                          <td style={style}>{att.clock_out || "-"}</td>
                          <td style={style}>{att.work_hour || "-"}</td>
                          <td style={style}>{att.overtime || "-"}</td>
                          <td style={style}>{att.shift_code || "-"}</td>
                        </React.Fragment>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            !loading && (
              <p className="text-center text-muted">No records found</p>
            )
          )}
        </div>
      </div>
       <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
    </div>
  );
};

export default Attendance_summary;
